import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { OffshoreLevel } from '../models/offshore-level';

@Injectable({
  providedIn: 'root',
})
export class OffshoreLevelService {
  API_URL = `${environment.apiUrl}/offshore-levels`;
  CACHE_SIZE = 1;
  private cache$!: Observable<Array<OffshoreLevel>>;
  isOffshoreLevelLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}
  get offshoreLevels() {
    if (!this.cache$) {
      this.cache$ = this.requestOffshoreLevels().pipe(shareReplay(this.CACHE_SIZE));
      this.isOffshoreLevelLoading$.next(true);
    }
    this.isOffshoreLevelLoading$.next(false);
    return this.cache$;
  }

  private requestOffshoreLevels() {
    return this.http.get<OffshoreLevel[]>(this.API_URL);
  }

  getAllOffshoreLevels(): Observable<OffshoreLevel[]> {
    return this.http.get<OffshoreLevel[]>(this.API_URL).pipe(
      map(offshoreLevels => offshoreLevels.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addOffshoreLevel(offshoreLevel: OffshoreLevel): Observable<OffshoreLevel> {
    return this.http.post<OffshoreLevel>(this.API_URL, offshoreLevel);
  }

  updateOffshoreLevel(offshoreLevel: OffshoreLevel): Observable<OffshoreLevel> {
    return this.http.put<OffshoreLevel>(`${this.API_URL}/${offshoreLevel.id}`, offshoreLevel);
  }

  deleteOffshoreLevel(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
  
}
